<template>

	<span class="" @click.stop="trigger">

		<input :key="key" ref="input" type="file" :accept="accept" :multiple="1" style="display:none;"
			@change="onInputChange" />


		<slot>
			<el-button type="primary" size="mini">点击上传</el-button>
		</slot>


	</span>

</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {},
		props: ['accept'],
		model: {
			prop: 'value',
			event: 'change'
		},
		data() {
			return {
				key: Date.now(),
				headers: request.makeHeaders(),
			}
		},
		mounted() {



		},
		methods: {

			trigger() {
				this.$refs.input.click();
			},
			onInputChange() {
				if (!event.target.files || !event.target.files.length) return;

				for (let i = 0; i < event.target.files.length; i++) {
					this.doFile(event.target.files[i]);
				}

				this.key = Date.now();

			},
			doFile(file) {
				if (file.size > 1024 * 1024 * 5) {
					this.$message.error('文件大小超出限制啦');
					return;
				}

				uploadFile({
					file,
					success: resp => {
						this.onSuccess(resp)
					},
					complete: () => {
						this.headers = request.makeHeaders();
					}
				})


			},
			onSuccess(resp) {
				console.log('onSuccess', resp)
				this.$emit('success', resp);
			},


		}
	}
</script>

<style>

</style>